// @flow
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';

declare var $: any;

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.render();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'blur input', selector: '#investment-amount, #quantity' })
  onInputForm(event: any) {
    const target = $(event.target);
    var inputVal = target.val().replace(/,|[^0-9]+/g, '');
    target.val(Number(inputVal).toLocaleString());
  }

  @on({ event: 'focus', selector: '#investment-amount' })
  onFocusTopForm() {
    const quantityForm = $('.company_share_stock_quantity');
    if (!quantityForm.hasClass('form-group-invalid')) {
      $('.input-group-append')
        .eq(0)
        .addClass('active-append');
      $('.input-group-append')
        .eq(1)
        .removeClass('active-append');
    }
  }

  @on({ event: 'focus', selector: '#quantity' })
  onFocusButtomForm() {
    $('.input-group-append')
      .eq(0)
      .removeClass('active-append');
    $('.input-group-append')
      .eq(1)
      .addClass('active-append');
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field').length) {
      $('.date-field').removeClass('focus');

      if ($('.date-field').val().length === 0) {
        $('.date-field').removeClass('form-control-active');
      }
    }
  }

  render() {
    const investmentAmount = $('#investment-amount').val();
    const quantity = $('#quantity').val();
    $('#investment-amount').val(Number(investmentAmount).toLocaleString());
    $('#quantity').val(Number(quantity).toLocaleString());

    this.initDateRangePicker(this.$el);
    $('.grouping')
      .children('.form-group')
      .addClass('mb-minus');
    $('span.input-group-text:contains("円")').addClass(
      'rounded-top-right text-muted',
    );
    $(
      'span.input-group-text:contains("個"), span.input-group-text:contains("株")',
    ).addClass('rounded-bottom-right text-muted');
  }
}
